import { DateTime } from 'luxon';
import { FC, useRef, useState } from 'react';

import FilterButton from '@/components/FilterDropdown/FilterButton';
import useOnClickOutside from '@/hooks/useOnClickOutside';

import VacationsApprovalFilterBox from './VacationApprovalsFIlterBox';

interface Props {
  selectedDepartments: number[];
  setSelectedDepartments: React.Dispatch<React.SetStateAction<number[]>>;
  selectedCompanies: number[];
  setSelectedCompanies: React.Dispatch<React.SetStateAction<number[]>>;
  selectedDateRange: { rangeStart?: DateTime; rangeEnd?: DateTime };
  setSelectedDateRange: React.Dispatch<
    React.SetStateAction<{ rangeStart?: DateTime; rangeEnd?: DateTime }>
  >;
}

const VacationApprovalsFilter: FC<Props> = ({
  selectedDepartments,
  setSelectedDepartments,
  selectedCompanies,
  setSelectedCompanies,
  selectedDateRange,
  setSelectedDateRange,
}) => {
  const [showFilter, setShowFilter] = useState(false);

  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => setShowFilter(false));

  const filterApplied =
    selectedDepartments.length > 0 ||
    selectedCompanies.length > 0 ||
    !!selectedDateRange.rangeStart;

  return (
    <div ref={ref}>
      <FilterButton
        onClick={() => {
          setShowFilter(!showFilter);
        }}
        isActive={!!showFilter}
        filterApplied={filterApplied}
      ></FilterButton>
      {showFilter && (
        <VacationsApprovalFilterBox
          closeFilter={() => setShowFilter(false)}
          selectedDepartments={selectedDepartments}
          setSelectedDepartments={setSelectedDepartments}
          selectedCompanies={selectedCompanies}
          setSelectedCompanies={setSelectedCompanies}
          selectedDateRange={selectedDateRange}
          setSelectedDateRange={setSelectedDateRange}
        />
      )}
    </div>
  );
};

export default VacationApprovalsFilter;
